import React from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { CurriculumTable } from './CurriculumTable'

const StudentCurriculumTable = () => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id

	return (
		<StudentTopMenuLayout activeMenu="Timeline" pageName="Timeline">
			<CurriculumTable studentId={effectiveStudentId} isStudentView={!isInstructorView} />
		</StudentTopMenuLayout>
	)
}

export { StudentCurriculumTable }
